/* Cosywe - page de suivi 17TRACK : barre de progression en 5 etapes, meme rendu que Veralign.
   Lit le titre de statut fourni par 17TRACK et affiche l'etape correspondante. */
(function () {
  if (location.pathname.toLowerCase().indexOf('/apps/17track') === -1) return;
  var LABELS = ['Commande en cours', 'Commande prête', 'En transit', 'Derniers kilomètres', 'Livré'];
  var css = [
    '#yq-trackingBox{border:1px solid rgba(0,0,0,.12)!important;border-radius:12px!important;padding:24px 16px!important}',
    '#cw-track-steps{margin:28px auto 8px;max-width:640px}',
    '#cw-track-steps ol{list-style:none;display:flex;margin:0;padding:0}',
    '#cw-track-steps li{flex:1;position:relative;text-align:center;font-size:13px;color:#8a8a8a;padding:0 2px}',
    '#cw-track-steps li:before{content:"";position:absolute;top:11px;left:-50%;width:100%;height:3px;background:#d9d9d9;z-index:0}',
    '#cw-track-steps li:first-child:before{display:none}',
    '#cw-track-steps li.cw-done:before,#cw-track-steps li.cw-current:before{background:#000}',
    '#cw-track-steps .cw-dot{position:relative;z-index:1;display:flex;align-items:center;justify-content:center;width:24px;height:24px;margin:0 auto 8px;border-radius:50%;border:2px solid #d9d9d9;background:#fff;font-size:13px;line-height:1;color:#fff}',
    '#cw-track-steps li.cw-done .cw-dot{border-color:#000;color:#000}',
    '#cw-track-steps li.cw-current .cw-dot{border-color:#000;background:#000;color:#fff}',
    '#cw-track-steps li.cw-done,#cw-track-steps li.cw-current{color:#000}',
    '#cw-track-steps li.cw-current{font-weight:700}',
    '@media(max-width:600px){#cw-track-steps li{font-size:11px}}'
  ].join('');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
  function has(t, l) { for (var i = 0; i < l.length; i++) { if (t.indexOf(l[i]) > -1) return true; } return false; }
  function stepFor(t) {
    t = (t || '').toLowerCase();
    if (has(t, ['introuvable', 'non livr', 'échec', 'echec', 'problème', 'probleme', 'alerte', 'exception'])) return -1;
    if (has(t, ['été livr', 'ete livr', 'est livr'])) return 4;
    if (has(t, ['cours de livraison', 'ramassage', 'retrait', 'retir', 'dernier'])) return 3;
    if (has(t, ['transit', 'expédi', 'expedi'])) return 2;
    if (has(t, ['prête', 'prete', 'préparation', 'reçu'])) return 1;
    if (has(t, ['traitement', 'passée', 'passee', 'enregistr', 'en attente', 'en cours'])) return 0;
    return -1;
  }
  function render() {
    var title = document.querySelector('.yq-track-shipment-title');
    var old = document.getElementById('cw-track-steps');
    if (!title) { if (old) old.remove(); return; }
    var s = stepFor(title.textContent);
    var host = title.closest('.yq-track-process') || title.parentElement;
    if (s < 0) { if (old) old.remove(); return; }
    if (old && old.getAttribute('data-step') === String(s) && old.parentElement === host) return;
    if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.id = 'cw-track-steps';
    wrap.setAttribute('data-step', String(s));
    var ol = document.createElement('ol');
    for (var i = 0; i < LABELS.length; i++) {
      var li = document.createElement('li');
      li.className = i < s ? 'cw-done' : (i === s ? 'cw-current' : '');
      var dot = document.createElement('span');
      dot.className = 'cw-dot';
      dot.textContent = i <= s ? '✓' : '';
      var lab = document.createElement('span');
      lab.textContent = LABELS[i];
      li.appendChild(dot);
      li.appendChild(lab);
      ol.appendChild(li);
    }
    wrap.appendChild(ol);
    host.appendChild(wrap);
  }
  var raf = 0;
  new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; render(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  render();
})();
